/* unplugin-vue-components disabled */const { computed, ref } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-118001de"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "basic-panel-wrap" };
const _hoisted_2 = {
    key: 0,
    class: "panel"
};
const _hoisted_3 = { class: "basic-sec-wrap" };
const _hoisted_4 = {
    key: 3,
    class: "panel"
};
const _hoisted_5 = {
    key: 4,
    style: { "display": "flex", "gap": "5px", "align-items": "center" },
    class: "panel"
};
const _hoisted_6 = {
    style: { "height": "100%" },
    class: "panel"
};
const _hoisted_7 = { class: "select-tip" };
const _hoisted_8 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "请选择", -1));
const _hoisted_9 = [
    _hoisted_8
];
const work_1 = require("@/store/modules/work");
const model_1 = require("@/model");
const index_vue_1 = tslib_1.__importDefault(require("@/components/DeviceDialg/index.vue"));
const PathPanel_1 = tslib_1.__importDefault(require("./PathPanel"));
const UcsPanel_vue_1 = tslib_1.__importDefault(require("./UcsPanel.vue"));
const PosePanel_vue_1 = tslib_1.__importDefault(require("./PosePanel.vue"));
const ToolPanel_vue_1 = tslib_1.__importDefault(require("@/views/design/components/ToolPanel.vue"));
const TcpPanel_vue_1 = tslib_1.__importDefault(require("@/views/design/components/TcpPanel.vue"));
const DeleteBtn_1 = tslib_1.__importDefault(require("@/components/DeleteBtn"));
const MachineItem_1 = tslib_1.__importDefault(require("./MachineItem"));
const SensitiveInput_1 = tslib_1.__importDefault(require("@/components/SensitiveInput"));
const one_message_1 = require("@/utils/one_message");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BasicPanel',
    setup(__props) {
        const curNode = computed(() => store.curNode);
        const rootMachine = computed(() => { var _a; return (_a = curNode.value) === null || _a === void 0 ? void 0 : _a.rootMachine; });
        const deviceDialog = ref(index_vue_1.default);
        const store = (0, work_1.useWork)();
        const isUcsPanelReadonly = computed(() => {
            var _a, _b, _c;
            if (((_a = curNode.value) === null || _a === void 0 ? void 0 : _a.type) === work_1.NODE_TYPE.TCP
                && ((_c = (_b = curNode.value) === null || _b === void 0 ? void 0 : _b.target) === null || _c === void 0 ? void 0 : _c.isTcpOrigin)) {
                return true;
            }
            return false;
        });
        const ucsPanelModel = computed(() => {
            var _a, _b;
            if (isTransformTypeNode(curNode.value)) {
                if (((_a = rootMachine.value) === null || _a === void 0 ? void 0 : _a.type) == model_1.ENTITY_TYPE.ROBOT) {
                    if ([work_1.NODE_TYPE.ROBOT, work_1.NODE_TYPE.UCS, work_1.NODE_TYPE.DEVICE].includes(curNode.value.type)) {
                        return rootMachine.value;
                    }
                    else if (((_b = curNode.value) === null || _b === void 0 ? void 0 : _b.type) === work_1.NODE_TYPE.TCP) {
                        return (rootMachine.value.tcps.find((e) => e.id == curNode.value.id));
                    }
                    else if (curNode.value.type === work_1.NODE_TYPE.TOOL) {
                        return rootMachine.value.tool;
                    }
                }
                else {
                    return rootMachine.value;
                }
            }
            return {};
        });
        function onClickAddFixture() {
            deviceDialog.value.show();
        }
        function handleDelPath() {
            if (!curNode.value)
                return;
            rootMachine.value.delPath(curNode.value.target.id);
            store.selectNode(null);
        }
        function isTransformTypeNode(node) {
            let showTransformTypes = [
                work_1.NODE_TYPE.ROBOT,
                work_1.NODE_TYPE.DEVICE,
                work_1.NODE_TYPE.UCS,
                work_1.NODE_TYPE.Table,
                work_1.NODE_TYPE.TCP,
                work_1.NODE_TYPE.TOOL,
            ];
            if ((node === null || node === void 0 ? void 0 : node.type) === work_1.NODE_TYPE.MENU && (node === null || node === void 0 ? void 0 : node.target).type == work_1.VIR_NODE_TYPE.N_TAIL) {
                if (rootMachine.value.tool) {
                    return true;
                }
                else {
                    return false;
                }
            }
            return showTransformTypes.includes(node === null || node === void 0 ? void 0 : node.type);
        }
        function getUcsPanelTitle(curNode) {
            var _a, _b, _c;
            if (curNode.type === work_1.NODE_TYPE.TCP || curNode.type === work_1.NODE_TYPE.UCS) {
                return ((_a = (rootMachine.value.tcps || []).find(e => e.id === curNode.id)) === null || _a === void 0 ? void 0 : _a.name) || rootMachine.value.name;
            }
            else if (curNode.type === work_1.NODE_TYPE.TOOL || curNode.type === work_1.VIR_NODE_TYPE.N_TAIL) {
                return ((_c = (_b = rootMachine.value) === null || _b === void 0 ? void 0 : _b.tool) === null || _c === void 0 ? void 0 : _c.name) || rootMachine.value.name;
            }
            else {
                return `${rootMachine.value.name} `;
            }
        }
        function contrastNodeType(contrastType) {
            var _a;
            if (curNode.value) {
                if (contrastType.includes(curNode.value.type)) {
                    return true;
                }
                else if (curNode.value.type === work_1.NODE_TYPE.MENU && contrastType.includes((_a = curNode.value.target) === null || _a === void 0 ? void 0 : _a.type)) {
                    return true;
                }
            }
            return false;
        }
        function handleUcsDel() {
            if (!curNode)
                return;
            let node = curNode.value;
            if ([work_1.NODE_TYPE.ROBOT, work_1.NODE_TYPE.UCS, work_1.NODE_TYPE.DEVICE].includes(node.type)) {
                model_1.Project.current().removeMachine(node.rootId);
            }
            else if (work_1.NODE_TYPE.TCP === node.type) {
                node.rootMachine.delTcp(node.target.id);
            }
            else if (work_1.NODE_TYPE.PATH === node.type) {
                node.rootMachine.delPath(node.target.id);
            }
            else if (work_1.NODE_TYPE.TOOL === node.type) {
                node.rootMachine.setTool(null);
            }
            store.selectNode(null);
        }
        function onPathNameBeforeChange(newValue) {
            if (rootMachine.value.paths.find(path => path.name === newValue)) {
                (0, one_message_1.oneMessage)({ message: '该路径名称已存在！', type: 'warning' });
                return false;
            }
            else {
                return true;
            }
        }
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f;
            const _component_el_card = (0, vue_2.resolveComponent)("el-card");
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (isTransformTypeNode((0, vue_2.unref)(curNode)) && (0, vue_2.unref)(rootMachine))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                            (0, vue_2.createVNode)(UcsPanel_vue_1.default, {
                                machine: (0, vue_2.unref)(ucsPanelModel),
                                "onUpdate:machine": _cache[0] || (_cache[0] = ($event) => ((0, vue_2.isRef)(ucsPanelModel) ? (ucsPanelModel).value = $event : null)),
                                isReadOnly: (0, vue_2.unref)(isUcsPanelReadonly),
                                isReferenceReadOnly: ((_a = (0, vue_2.unref)(curNode)) === null || _a === void 0 ? void 0 : _a.type) === (0, vue_2.unref)(work_1.NODE_TYPE).ROBOT || (0, vue_2.unref)(curNode).type === (0, vue_2.unref)(work_1.NODE_TYPE).DEVICE,
                                "is-show-del-btn": !(0, vue_2.unref)(isUcsPanelReadonly),
                                onDelConfirm: handleUcsDel
                            }, null, 8, ["machine", "isReadOnly", "isReferenceReadOnly", "is-show-del-btn"])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (isTransformTypeNode((0, vue_2.unref)(curNode)) && (0, vue_2.unref)(rootMachine))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_card, {
                                key: 0,
                                id: "machine-item-mobile-wrap"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(MachineItem_1.default), {
                                        machine: (0, vue_2.unref)(ucsPanelModel),
                                        "is-read-only": (0, vue_2.unref)(isUcsPanelReadonly),
                                        "is-show-del-btn": !(0, vue_2.unref)(isUcsPanelReadonly)
                                    }, null, 8, ["machine", "is-read-only", "is-show-del-btn"])
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (((_b = (0, vue_2.unref)(curNode)) === null || _b === void 0 ? void 0 : _b.type) === (0, vue_2.unref)(work_1.NODE_TYPE).ROBOT && (0, vue_2.unref)(rootMachine))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_card, {
                                key: 1,
                                class: "pose-panel-wrap panel"
                            }, {
                                default: (0, vue_2.withCtx)(() => {
                                    var _a;
                                    return [
                                        (0, vue_2.createVNode)(PosePanel_vue_1.default, {
                                            "ucs-transform": (_a = (0, vue_2.unref)(rootMachine)) === null || _a === void 0 ? void 0 : _a.tcps[0].pr,
                                            robot: (0, vue_2.unref)(rootMachine),
                                            title: "姿态调整",
                                            ucsTitle: "末端调整"
                                        }, null, 8, ["ucs-transform", "robot"])
                                    ];
                                }),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (contrastNodeType([(0, vue_2.unref)(work_1.NODE_TYPE).TOOL, (0, vue_2.unref)(work_1.VIR_NODE_TYPE).N_TAIL]) && (0, vue_2.unref)(rootMachine))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_card, {
                                key: 2,
                                class: "panel"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(ToolPanel_vue_1.default, {
                                        onAddToolClk: onClickAddFixture,
                                        machine: (0, vue_2.unref)(rootMachine)
                                    }, null, 8, ["machine"])
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (contrastNodeType([(0, vue_2.unref)(work_1.VIR_NODE_TYPE).N_TCP]) && (0, vue_2.unref)(rootMachine))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                (0, vue_2.createVNode)(TcpPanel_vue_1.default, { machine: (0, vue_2.unref)(rootMachine) }, null, 8, ["machine"])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (((_c = (0, vue_2.unref)(curNode)) === null || _c === void 0 ? void 0 : _c.type) === (0, vue_2.unref)(work_1.NODE_TYPE).PATH)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                (0, vue_2.createVNode)((0, vue_2.unref)(SensitiveInput_1.default), {
                                    model: (0, vue_2.unref)(curNode).target.name,
                                    "onUpdate:model": _cache[1] || (_cache[1] = ($event) => (((0, vue_2.unref)(curNode).target.name) = $event)),
                                    maxlength: 15,
                                    "before-change": onPathNameBeforeChange
                                }, null, 8, ["model"]),
                                (0, vue_2.createVNode)((0, vue_2.unref)(DeleteBtn_1.default), {
                                    title: "确定删除这条路径吗？",
                                    onDelConfirm: handleDelPath
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_button, null, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)("删除")
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(PathPanel_1.default), {
                                robot: (0, vue_2.unref)(rootMachine),
                                onPathNameBeforeChange: onPathNameBeforeChange
                            }, null, 8, ["robot"])
                        ], 512), [
                            [vue_2.vShow, ((_d = (0, vue_2.unref)(curNode)) === null || _d === void 0 ? void 0 : _d.type) === (0, vue_2.unref)(work_1.NODE_TYPE).MENU && ((_f = (_e = (0, vue_2.unref)(curNode)) === null || _e === void 0 ? void 0 : _e.target) === null || _f === void 0 ? void 0 : _f.type) === (0, vue_2.unref)(work_1.VIR_NODE_TYPE).N_PATH && (0, vue_2.unref)(rootMachine)]
                        ])
                    ]),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_7, _hoisted_9, 512), [
                        [vue_2.vShow, !(0, vue_2.unref)(curNode)]
                    ])
                ]),
                (0, vue_2.createVNode)(index_vue_1.default, {
                    ref_key: "deviceDialog",
                    ref: deviceDialog,
                    showTypes: ['fixture'],
                    isUseCurDevice: true,
                    isImportScene: false
                }, null, 512)
            ], 64));
        };
    }
});
